import React from "react";
import AllSubjectTopics from "../../../Topics/AllSubjectTopics";



function MnemonicPhysTopics() {



  return (
    <>

      <AllSubjectTopics  subject="physics" type="mnemonic" />

    </>
  );
}

export default MnemonicPhysTopics;